<template lang="pug">
  section
    .videowrapper(v-if="video")
      video(:src="video" muted autoplay loop playsinline)
    .iframewrapper(v-if="iframe")
      .iframe(v-html="iframe")
</template>
<script>
export default {
  props: {
    video: String,
    iframe: String
  }
}
</script>
<style lang="scss" scoped>
  .iframewrapper{
    position: relative;
    padding-top: 56.25%;
    padding-bottom: 0;
    height: 0;
    width: 100%;
    >>>iframe{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .videowrapper{
    width: 100%;
    height: 100vh;
    position: relative;
    background-color: blue;
    overflow: hidden;
    &:before{
      // content: '';
      // top: 0;
      // left: 0;
      // right: 0;
      // bottom: 0;
      // background: url(../assets/grid.png);
      // position: absolute;
      // z-index: 2;
    }
    video{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
    }
  }
</style>


